export default "__VITE_ASSET__TuPv16Cx__"